var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 py-2 d-flex align-items-center"},[_c('div',{staticClass:"ml-3 d-flex flex-column"},[_c('small',[_c('span',{staticClass:"text-info"},[_vm._v("ชื่อ")]),_vm._v(" "+_vm._s(_vm.name))]),_c('small',[_c('span',{staticClass:"text-info"},[_vm._v("หน่วยงาน")]),_vm._v(" "+_vm._s(_vm.department ? _vm.department : ""))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }